/** The id of the guest the API answers `me` with when there is no session. */
export const GUEST_USER_ID = 'ombu:guest';

/**
 * Whether `user` is a real, signed-in account: present and not the guest. An
 * exact match on the guest id, as the API's `isGuestUser` does — shared by both
 * frontends so neither drifts back to a substring test a real id could pass.
 */
export const isSignedIn = (user: { id: string } | null | undefined): boolean =>
  Boolean(user && user.id !== GUEST_USER_ID);
